
import { MultiFileService } from "@/services/MultiFileService.js";
import {required, maxLength} from "vuelidate/lib/validators";
import Select2Multiple from "v-select2-multiple-component";
import flatPickr from 'vue-flatpickr-component';
import upLoad from '@/assets/img/upload_photo3.jpg';

export default {
  name: 'TeacherLeaveForm',
  components: {
    flatPickr,
    Select2Multiple,
  },

  props: {
    leaveData: { type: Object, required: true },
    submitted: { type: Boolean, default: false },
    images: { type: Array, default: () => [] },
    existingImages: { type: Array, default: () => [] },
  },

  emits: ["update:leaveData", "update:images", "update:existingImages", 'validations'],

  data() {
    return {
      localLeaveData: { ...this.leaveData },
      localImages: [...this.images],
      localExistingImages: [...this.existingImages],
      periodOptions: [
        { id: '0', text: 'Morning' },
        { id: '1', text: 'Evening' },
        { id: '2', text: 'Full' },
      ],
      upLoad,
    };
  },

  validations: {
    localLeaveData: {
      period: {
        required,
      },
      leave_reason: {
        required,
        maxLength: maxLength(1000)
      },
      from_date: {
        required,
      },
      to_date: {
        required,
        afterOrEqualFromDate(value) {
          if (!value || !this.localLeaveData.from_date) return true;
          return new Date(value) >= new Date(this.localLeaveData.from_date);
        },
      },
      request_date: {
        required,
      },
      status: {
        required,
      },
      remark: {
        maxLength: maxLength(1000)
      }
    },
  },

  methods: {
    chooseFiles(id) {
      MultiFileService.chooseFiles(id);
    },

    onFileChange(e) {
      MultiFileService.onFileChange({
        event: e,
        newFiles: this.localImages,
        existingFiles: this.localExistingImages,
        allowedFileTypes: ["image/*"],
        maxFileSize: 4, // 4 MB
        maxFileCount: 5,
        refs: this.$refs
      });
    },

    removeImage(i) {
      MultiFileService.removeFile(i, this.localImages);
    },

    removeExistingImage(id) {
      const indexInExistingImages = this.localExistingImages.findIndex(img => img.id === id);
      if (indexInExistingImages !== -1) {
        MultiFileService.removeFile(indexInExistingImages, this.localExistingImages);
      }
    },
  },

  watch: {
    // Watch localLeaveData → emit to parent when changed
    localLeaveData: {
      deep: true,
      handler(newVal) {
        this.$emit('update:leaveData', newVal);
      },
    },

    localImages: {
      deep: true,
      handler(newVal) {
        this.$emit('update:images', newVal);
      },
    },

    localExistingImages: {
      deep: true,
      handler(newVal) {
        this.$emit('update:existingImages', newVal);
      },
    },

    // If parent componement updates teacher_id, sync back to locals
    'leaveData.teacher_id': {
      deep: false,
      handler(newVal) {
        this.localLeaveData.teacher_id = newVal;
      },
    },

    'localLeaveData.period'(newVal) {
      if (!newVal) return;

      const exists = this.periodOptions.some(opt => opt.id == newVal);
      if (!exists) {
        this.localLeaveData.period = null;
        this.periodOptions = [...this.periodOptions];
      }
    }
  },

  mounted() {
    //then emit validations to parent
    this.$nextTick(() => {
      if (this.$v) {
        this.$emit("validations", this.$v);
      }
    });
  },
}
